import { render } from "./sensor-type-form.vue?vue&type=template&id=fe18bd12"
import script from "./sensor-type-form.vue?vue&type=script&lang=js"
export * from "./sensor-type-form.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__